import { render } from "./container-details-specifics.vue?vue&type=template&id=8fc2972e&scoped=true"
import script from "./container-details-specifics.vue?vue&type=script&lang=js"
export * from "./container-details-specifics.vue?vue&type=script&lang=js"

import "./container-details-specifics.vue?vue&type=style&index=0&id=8fc2972e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc2972e"]])

export default __exports__